// extracted by mini-css-extract-plugin
module.exports = {"inputSmall":"date_inputSmall__24l-r","inputLarge":"date_inputLarge__shOLG"};